import { Type } from "class-transformer";
import { FrontendFieldDefinition } from "src/modules/sm-base/models/frontend-field-definition.model";
import { AuthRules } from "src/modules/sm-base/shared/auth-rules.model";
import { OrdinaryObject } from "src/modules/utils/shared/ordinary-object.model";
import { MainFrontendConfigFieldAccess } from "./main-frontend-config-field-access.enum";
import { GenericObjectDefinition } from "src/modules/sm-base/models/generic-object-definition.model";

export class MainFrontendConfig {
    @Type(() => FrontendFieldDefinition)
    additionalUserAttributes: FrontendFieldDefinition[] = [];
    @Type(() => FrontendFieldDefinition)
    additionalUserGroupAttributes: FrontendFieldDefinition[] = [];
    @Type(() => GenericObjectDefinition)
    genericObjectDefinitions: GenericObjectDefinition[] = [];
    @Type(() => AuthRules)
    authRules: AuthRules;
    useAdminUsers = false;
    adminUsersAllowAdd = true;
    useAdminUserGroups = false;
    adminUsersFieldAccess: OrdinaryObject<MainFrontendConfigFieldAccess> = {};
       

    init(): void {
        this.additionalUserAttributes ??= [];
        this.additionalUserGroupAttributes ??= [];
        this.authRules ??= new AuthRules();
    }
}